import { useMemo } from 'react';
import { useApi } from '../infrastructure/useApi';
import { DEFAULT_API_OPTIONS } from '../infrastructure/defaults';
import { API_URLS } from '../apiUrls';
import { API_METHODS } from '../constants/apiMethods';

/**
 * Hook for accessing Order Requests API methods.
 *
 * Usage:
 * const { submitOrderRequest, cancel } = useOrderRequestsApi();
 * await submitOrderRequest(payload);
 *
 * Cancellation scope:
 * - cancel() applies to requests started by this hook instance.
 * - For independent cancellation scopes, create separate hook instances.
 */
export const useOrderRequestsApi = (baseOptions = DEFAULT_API_OPTIONS) => {
	const { call, cancel } = useApi(baseOptions);

	return useMemo(
		() => ({
			submitOrderRequest: (payload) =>
				call({
					url: API_URLS.orderRequest.submitOrderRequest(),
					method: API_METHODS.POST,
					payload,
				}),

			cancel,
		}),
		[call, cancel]
	);
};
